import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'grid',
      gridTemplateRows: '1fr',
      gridTemplateColumns: '6fr 6fr',
      gridTemplateAreas: "'content media'",
      gridGap: Spacings.s64,
      maxWidth: 1380,
      margin: 'auto',

      '&.reversed': {
        gridTemplateAreas: "'media content'",
        [mediaQuery(1023)]: {
          gridTemplateAreas: "'content' 'media'",
        },
      },

      [mediaQuery(1023)]: {
        gridTemplateAreas: "'content' 'media'",
        gridTemplateColumns: '1fr',
        gridGap: 0,
        margin: [0, 'auto'],
        maxWidth: '100%',
      },
    },
    mediaWrapper: {
      gridArea: 'media',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',

      [mediaQuery(1023)]: {
        gridArea: 'media',
        maxWidth: '100%',
        width: '100%',
      },
    },
    productWrapper: {
      maxWidth: 648,
      width: '100%',
      padding: [96, Spacings.s0],
      gridArea: 'content',

      [mediaQuery(1023)]: {
        textAlign: 'center',
        maxWidth: '100%',
        width: '100%',
        padding: [94, Spacings.s0, Spacings.s72, Spacings.s0],
        gridArea: 'content',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s44, Spacings.s0],
      },
    },

    //  SKELETON
    titleFallback: {
      height: 32,
    },
    bulletsFallback: {
      display: 'grid',
      gridTemplateRows: '1fr 1fr',
      gridTemplateColumns: '1fr 1fr',
      gap: Spacings.s16,
      marginBottom: Spacings.s24,

      '& > .skeleton': {
        height: 32,
      },
    },
    actionFallback: {
      width: 240,
      height: 56,
    },
    descFallback: {
      height: 32,
    },
  }),
  {
    name: 'animated-banner-with-bullets',
  },
);

export default useStyles;
